import { camelize } from 'casing'
import { AxiosError, AxiosResponse } from 'axios'
import { fetchSellerData, fetchSellerDataMicrosoft } from '../../api/seller'
import { startLoading, stopLoading } from '../../modules/loading/actions'
import { LoadingTypes } from '../../modules/loading/reducer'
import { errorLogger } from '../../utils/errorLogger'

const SET_FLYOUT_LISTING_DATA = 'SET_FLYOUT_LISTING_DATA'
const SET_FLYOUT_LISTING_DATA_MICROSOFT = 'SET_FLYOUT_LISTING_DATA_MICROSOFT'

const setListingData = (listingData: Record<string, unknown>) => ({
  type: SET_FLYOUT_LISTING_DATA,
  payload: listingData,
})

const setListingDataMicrosoft = (listingDataMicrosoft: unknown) => ({
  type: SET_FLYOUT_LISTING_DATA_MICROSOFT,
  payload: listingDataMicrosoft,
})

export const getFlyoutListingData =
  ({
    partnerId,
    metadata = false,
  }: {
    partnerId: string
    metadata?: boolean
  }) =>
  async (
    dispatch: (action: unknown) => Promise<unknown>,
    getState: () => unknown
  ) => {
    dispatch(startLoading(LoadingTypes.MARKETPLACE_INFO))
    try {
      const { data } = await fetchSellerData({
        partnerId,
        metadata: { metadata },
      })
      const camelizedData = camelize(data) as Record<string, unknown> & {
        type?: unknown
      }
      const transformedData = {
        ...camelizedData,
        ...(camelizedData.type ? { sellerType: camelizedData.type } : {}),
      }
      delete transformedData.type
      await dispatch(setListingData(transformedData))
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<{
        track_id?: string
      }>
      errorLogger({ globalState: getState() as never })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      dispatch(stopLoading(LoadingTypes.MARKETPLACE_INFO))
    }
  }

export const getFlyoutListingDataMicrosoft =
  ({ accountId }: { accountId: string }) =>
  async (
    dispatch: (action: unknown) => Promise<unknown>,
    getState: () => unknown
  ) => {
    dispatch(startLoading(LoadingTypes.MARKETPLACE_INFO_MICROSOFT))
    try {
      const { data } = await fetchSellerDataMicrosoft({
        accountId,
      })
      await dispatch(setListingDataMicrosoft(camelize(data)))
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<{
        track_id?: string
      }>
      const globalState = getState()
      errorLogger({ globalState: globalState as never })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      dispatch(stopLoading(LoadingTypes.MARKETPLACE_INFO_MICROSOFT))
    }
  }
